import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { SubscriptionNotificationsSearchResponse } from '@/types/subscriptionNotification';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  /** Mongo-style filter and `$orderby` object, JSON-encoded into `query`. */
  query: Readonly<Record<string, unknown>>;
  /** 1-based. */
  page: number;
  limit: number;
  /** Columns to select, JSON-encoded into `fields`; the endpoint groups rows by channel_name and subscription_id, so keep both. */
  fields?: readonly string[];
};

export const searchSubscriptionNotifications = async (
  scope: RequestScope,
  { query, page, limit, fields }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<SubscriptionNotificationsSearchResponse>> => {
  try {
    const response = await scopedChannelApi(scope).get<SubscriptionNotificationsSearchResponse>('subscription-notifications/search', {
      ...options,
      params: { query: JSON.stringify(query), page, limit, ...(fields ? { fields: JSON.stringify(fields) } : {}) },
    });
    return { result: response.data, status: response.status, execution_time: 0, num_results: 1 };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
